import React, { Component } from 'react'
import { connect } from 'react-redux'
import DashboardContainer from 'containers/DashboardContainer'
import LoadingScreen from 'components/LoadingScreen'
import TextInputElement from 'components/forms/TextInputElement'
import SignUpDetailInformation from './SignUpDetailInformation/SignUpDetailInformation'

import SuccessfulPanel from 'containers/time-poll/panels/SuccessfullyContainer'
import SubscribeContainer from 'containers/time-poll/panels/SubscribeContainer'
import EmailPanel from 'containers/time-poll/panels/EmailContainer'
import ThanksPanel from 'containers/time-poll/panels/ThanksContainer'
import LoginComponent from './LoginPhone/loginPhone'
import EmailComponent from './LoginEmail/LoginEmail'
import DeletedPanel from 'containers/time-poll/panels/DeletedContainer'
import OpenInAppModal from 'src/components/OpenInAppModal'
import SignUpDetailCard from '../CreateSignUp/SignUpDetailCard/SignUpDetailCard'
import { routerActions } from 'react-router-redux'

import AccountIcon from 'assets/icons/account-icon.png'
import EditIcon from 'assets/icons/edit-icon.png'
import unionCloseIcon from 'assets/icons/union-close-icon.png'
import unionIconGray from 'assets/icons/union-icon-gray.png'
import { uuid } from 'containers/time-poll/services/poll_helpers'

import PropTypes from 'prop-types'
import cn from 'classnames'

import { fetchSignUp, list_update } from 'src/actions/timepoll'
import { fetchCurrentUser, fetchEventById } from 'src/actions'
import { signUpDetailSelector, userSelector, contactMethodsSelector } from 'src/selectors'

import styles from './sign-up-detail.scss'

const initComponentStatus = {
  status: false,
  login: false,
  subscribe: false,
  email: false
}

function getAnonymousName() {
  const anonymousUser = JSON.parse(localStorage.getItem('anonymousUser'))
  const anonymousId = localStorage.getItem('anonymousId')
  if (anonymousUser && anonymousUser.id === anonymousId) {
    return anonymousUser.name
  }

  return ''
}

class SignUpDetail extends Component {
  state = {
    componentStatus: initComponentStatus,
    name: getAnonymousName(),
    showLogin: false,
    showEmail: false,
    eventDetail: null
  }

  componentDidMount() {
    if (!localStorage.getItem('anonymousId')) {
      localStorage.setItem('anonymousId', uuid())
    }

    const {
      params: { signUpToken: token },
      onGetSignUpDetails,
      onGetEventDetails
    } = this.props
    onGetSignUpDetails({
      token,
      onSuccessCallback: () => {
        if (this.props.signUpDetail?.event_id) {
          onGetEventDetails({
            ids: [this.props.signUpDetail.event_id],
            onSuccessCallback: data => {
              this.setState({ eventDetail: data.data.events[0] })
            }
          })
        }
      }
    })
  }

  _setName = event => {
    this.setState({ name: event.target.value })

    localStorage.setItem(
      'anonymousUser',
      JSON.stringify({
        id: localStorage.getItem('anonymousId'),
        name: event.target.value
      })
    )
  }

  handleUpdateSuccess = () => {
    this.setState({ updatedStatus: true })
  }

  handleClose = () => {
    const { signUpDetail, onSignUpFormSubmit } = this.props
    const list_options_params = signUpDetail.poll_options.map(item => ({
      id: item.id,
      count_limit: item.count_limit,
      description: item.description,
      item: item.item,
      item_rank: item.item_rank
    }))

    onSignUpFormSubmit({
      list_params: { id: signUpDetail.id, status: 'closed' },
      list_options_params,
      onSuccessCallback: () => {
        alert('Closed successfully')
        window.location.reload()
      }
    })
  }

  getCurrentComponent = () => {
    const { signUpDetail, onChangeTab } = this.props
    const { updatedStatus } = this.state

    const components = {
      loading: <LoadingScreen />,
      subscribe: <SubscribeContainer handleBackClick={() => onChangeTab()} />,
      successful: <SuccessfulPanel handleBackClick={() => onChangeTab()} poll={signUpDetail} />,
      email: <EmailPanel handleBackClick={() => onChangeTab()} />,
      thanks: <ThanksPanel poll={signUpDetail} handleBackClick={() => onChangeTab()} />,
      deleted: <DeletedPanel />
    }

    if (!signUpDetail) {
      return components.loading
    }

    if (signUpDetail.destroyed_at) {
      return components.deleted
    }

    if (updatedStatus) {
      if (this.props.user) {
        if (signUpDetail.email_require) {
          if (
            this.props.contactMethods.isThereAnEmail === false &&
            this.props.subscribeToMailchimpStatus !== 'success'
          ) {
            return components.email
          } else if (
            this.props.contactMethods.isThereAnEmail === false &&
            this.props.subscribeToMailchimpStatus === 'success'
          ) {
            return components.thanks
          }

          return components.successful
        }

        return components.successful
      } else {
        return components.subscribe
      }
    }

    return null
  }

  _getChildComponent = () => {
    const { showLogin, showEmail, name } = this.state
    const { onChangeTab } = this.props

    if (showLogin) {
      return (
        <LoginComponent onNextStep={() => onChangeTab()} handleBackClick={() => onChangeTab()} />
      )
    }

    if (showEmail) {
      return (
        <EmailComponent onNextStep={() => onChangeTab()} handleBackClick={() => onChangeTab()} />
      )
    }
    return (
      <SignUpDetailInformation
        ref="signUpDetailInformationRef"
        anonymousName={name}
        onUpdateSuccess={this.handleUpdateSuccess}
        eventInvitations={this.state.eventDetail?.invitations}
      />
    )
  }

  _getButtonComponent = () => {
    const isDesktop = window.innerWidth >= 1080
    const { user, signUpDetail, goEditRoute } = this.props
    const { showLogin } = this.state
    if (signUpDetail.status === 'closed') {
      return
    }

    if (user) {
      if (user.id === signUpDetail.creator.id) {
        return (
          <div className={styles['button-wrapper']}>
            <div className={styles['button-item']} onClick={this.handleClose}>
              <img src={unionCloseIcon} width="30" />
              <span className={styles['button-text']}>{isDesktop ? 'close list' : 'close'}</span>
            </div>
            <div
              className={cn(styles['button-item'], styles['button-item-full'])}
              onClick={() =>
                this.refs.signUpDetailInformationRef
                  .getWrappedInstance()
                  .setState({ isOpenFullModal: true })
              }
            >
              <img src={unionIconGray} width="30" />
              <span className={styles['button-text']}>full list</span>
            </div>
            <div
              className={styles['button-item']}
              onClick={() => goEditRoute('/su/edit/' + signUpDetail.token)}
            >
              <img src={EditIcon} width="30" />
              <span className={cn(styles['button-text'], styles['button-text-edit'])}>
                {isDesktop ? 'edit list' : 'edit'}
              </span>
            </div>
          </div>
        )
      }

      return null
    }

    if (!showLogin) {
      return (
        <div className={styles['user-wrapper']}>
          <div className={styles['name-wrapper']}>
            <img src={AccountIcon} alt="" width="18" />
            <TextInputElement
              className={styles['input-inner']}
              placeholder="Enter your name"
              onChange={this._setName}
              valid
              value={this.state.name}
            />
          </div>
          <div className={styles['account-wrapper']}>
            <span>Have an account?</span>
            <span
              className={styles['login-text']}
              onClick={() => this.setState({ showLogin: true })}
            >
              Login here
            </span>
          </div>
        </div>
      )
    }
  }

  getSignUpDetail = () => {
    const { signUpDetail } = this.props
    const { eventDetail } = this.state
    return {
      name: signUpDetail.name,
      image: signUpDetail.image_upload.image_url,
      avatar: signUpDetail.creator.avatar.small_url_2x,
      eventName: eventDetail?.name,
      ends_at: signUpDetail.ends_at,
      createName:
        signUpDetail.custom_creator_name ||
        `${signUpDetail.creator.first_name} ${signUpDetail.creator.last_name}`,
      created_at: signUpDetail.created_at,
      notes: signUpDetail.notes
    }
  }

  render() {
    const currentComponent = this.getCurrentComponent()
    const { showLogin } = this.state
    const isDesktop = window.innerWidth >= 1080

    if (this.props.showLoadingScreen) {
      return <LoadingScreen />
    }

    if (currentComponent) {
      return currentComponent
    }

    if (isDesktop) {
      return (
        <DashboardContainer>
          <div className={styles['sign-up-container']}>
            <div
              className={cn(styles['sign-up-info-wrapper'], {
                [styles['sign-up-info-wrapper-login']]: showLogin
              })}
            >
              <SignUpDetailCard signUpDetail={this.getSignUpDetail()} />
              {this._getButtonComponent()}
            </div>
            <div className={styles['sign-up-option-wrapper']}>{this._getChildComponent()}</div>
          </div>
        </DashboardContainer>
      )
    } else {
      return (
        <DashboardContainer>
          <div className={styles['sign-up-container']}>
            <div className={styles['sign-up-container-mobile']}>
              <div
                className={cn(styles['sign-up-info-wrapper'], {
                  [styles['sign-up-info-wrapper-login']]: showLogin
                })}
              >
                <SignUpDetailCard signUpDetail={this.getSignUpDetail()} />
                {this._getButtonComponent()}
              </div>
              <div className={styles['sign-up-option-wrapper']}>{this._getChildComponent()}</div>
            </div>
          </div>
          <OpenInAppModal />
        </DashboardContainer>
      )
    }
  }
}

SignUpDetail.propTypes = {
  user: PropTypes.object,
  params: PropTypes.object,
  onGetSignUpDetails: PropTypes.func,
  signUpDetail: PropTypes.object,
  onChangeTab: PropTypes.func,
  contactMethods: PropTypes.object,
  subscribeToMailchimpStatus: PropTypes.string,
  onGetEventDetails: PropTypes.func,
  goEditRoute: PropTypes.func,
  onSignUpFormSubmit: PropTypes.func,
  showLoadingScreen: PropTypes.bool
}

function mapStateToProps(state) {
  return {
    user: userSelector(state),
    signUpDetail: signUpDetailSelector(state),
    contactMethods: contactMethodsSelector(state),
    subscribeToMailchimpStatus: state.frontend.subscribeToMailchimpStatus,
    showLoadingScreen: state.frontend.showLoadingScreen
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onGetSignUpDetails: params => dispatch(fetchSignUp(params)),
    onGetEventDetails: params => dispatch(fetchEventById(params)),
    onChangeTab: () => {
      dispatch(fetchCurrentUser())
      window.location.reload()
      window.scrollTo(0, 0)
    },
    goEditRoute: params => dispatch(routerActions.push(params)),
    onSignUpFormSubmit: params => dispatch(list_update(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpDetail)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/SignUpDetail/SignUpDetail.jsx